import PropTypes from 'prop-types';

import Heading from 'shopper/components/Heading';

import placeholder from 'lib/placeholder';

import BlueCard from './BlueCard';
import PurpleCard from './PurpleCard';

const Strategies = ({ className }) => (
  <section className={className}>
    <Heading as="h3" className="mb-6 text-center" size="size2">
      {placeholder('titles.ourStrategies')}
    </Heading>
    <PurpleCard className="mb-2 md:mb-0" />
    <BlueCard />
  </section>
);

Strategies.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default Strategies;
